import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-endorsement-request',
  templateUrl: './endorsement-request.component.html',
  styleUrls: ['./endorsement-request.component.css']
})
export class EndorsementRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
